import { Component, type ReactNode } from 'react';
import { Button } from '@/components/ui/button';

type ErrorBoundaryProps = {
  children: ReactNode;
};

type ErrorBoundaryState = {
  hasError: boolean;
};

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-arena p-6">
          <div className="text-center space-y-4">
            <h1 className="text-2xl font-display font-bold">Oops! Something went wrong</h1>
            <p className="text-sm text-muted-foreground">
              Reload the game to recover your session.
            </p>
            <Button onClick={() => window.location.reload()}>
              Reload Game
            </Button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
